import React, { Component } from "react"
import PropTypes from "prop-types"
import WidgetHeader from "./WidgetHeader"

class Widget extends Component {
  /*constructor() {
    super()
    this.state = { hide: false }
  }*/ // This is the same as just state = { hide: false }

  state = { hide: false }

  static propTypes = {
    widthLg: PropTypes.number.isRequired,
    widthMd: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  }

  render() {
    const css = `col-lg-${this.props.widthLg} col-md-${this.props.widthMd}`
    return (
      <div className={css}>
        <div className="card">
          <div className="card-block">
            <div className="row">
              <WidgetHeader title={this.props.title} />
              <div className="col-12">{this.props.children}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Widget



// WEBPACK FOOTER //
// ./src/Components/Widgets/Layout/Widget.js